var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.labResult)?_c('w-lab',{staticClass:"lab-module",attrs:{"backUrl":("/mypools/" + _vm.poolId),"pool":_vm.labResult,"status-colors":_vm.statusColors}}):_vm._e(),_c('w-version')],1)}
var staticRenderFns = []

export { render, staticRenderFns }